import axios from 'axios';

// API Configuration for different environments
const getApiBaseUrl = () => {
  if (process.env.NODE_ENV === 'production') {
    // Your actual Render backend URL
    return 'https://newcrmdash.onrender.com/api';
  }
  // Development - uses proxy from package.json
  return '/api';
};

export const API_BASE_URL = getApiBaseUrl();

// Set base URL for all API calls
axios.defaults.baseURL = API_BASE_URL;

// Add request interceptor to include token
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle auth errors
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default axios; 